import axios from "axios"

const client = axios.create({
  baseURL: process.env.NEXT_PUBLIC_NODE_API,
})

client.interceptors.request.use((request) => {
  console.log("Starting Request", `${request.baseURL}${request.url}`)
  return request
})

export const axiosNodeClient = client
